import React, { Fragment, PureComponent, ReactElement } from 'react';
import { Country } from '~/Api/Country';
import { Product as GeneralProduct } from '~/Api/Product';
import { Product } from '~/Api/User/ProductGroup/CzMaxPrice';

import Row, { OnChangeListener, OnSelectListener, Values } from './Row';
import { ProductTableRowEmpty } from '~/libs/ui/molecules/ProductTableRowEmpty';
import { ProductTableHeader } from '~/libs/ui/molecules/ProductTableHeader';

export interface ProductRow {
	country: Country;
	product: Product | null;
	lowestPriceIndex: number | null;
}

export type ProductValues = Values;

interface Props {
	products: ProductRow[];
	productValues: { [key in string]: Values };
	referencePackageSize: number | null;
	detailLink(product: { id: string }): { pathname: string; search: string };
	highlightProductId: string | null;
	lastSelectedProductId: string | null;
	disableSelection: boolean;
	onChange: OnChangeListener;
	onSelect: OnSelectListener;
	onSave(): void;
	checkedRows: GeneralProduct[];
	checkRow(product: GeneralProduct, checked: boolean): void;
}

export default class ProductsTable extends PureComponent<Props> {
	static defaultProps = {
		referencePackageSize: null,
		highlightProductId: null,
		lastSelectedProductId: null,
		disableSelection: false,
	};

	render() {
		const { products } = this.props;

		return (
			<Fragment>
				<ProductTableHeader />
				{products.map((optionalProduct) => {
					const { country, product, lowestPriceIndex } = optionalProduct;
					return product !== null ? (
						this.renderRow(product, lowestPriceIndex)
					) : (
						<ProductTableRowEmpty key={country.alpha2} countryAlpha={country.alpha2} countryName={country.name} />
					);
				})}
			</Fragment>
		);
	}

	renderRow(czMaxPriceProduct: Product, lowestPriceIndex: number | null): ReactElement {
		const {
			productValues,
			referencePackageSize,
			disableSelection,
			highlightProductId,
			lastSelectedProductId,
			detailLink,
			onChange,
			onSelect,
			onSave,
			checkRow,
		} = this.props;
		const { product } = czMaxPriceProduct;
		const checked = this.props.checkedRows?.some((row) => row.id === product.id);
		return (
			<Row
				czMaxPriceProduct={czMaxPriceProduct}
				detailLink={detailLink}
				disableSelection={disableSelection}
				highlightProduct={highlightProductId === product.id}
				checked={checked}
				checkRow={(value) => checkRow(product, value)}
				key={product.id}
				lastSelectedProduct={lastSelectedProductId === product.id}
				lowestPriceIndex={lowestPriceIndex}
				referencePackageSize={referencePackageSize}
				values={productValues[product.id]}
				onChange={onChange}
				onSave={onSave}
				onSelect={onSelect}
			/>
		);
	}
}
